export function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/common/compact.js
// module id = ./node_modules/@apollo/client/utilities/common/compact.js
// module chunks = 54 55